// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Grid, Card, Icon } from 'semantic-ui-react'

export default class Thanks extends Component {
  render () {
    return (
      <Grid.Column width='5'>
        <Card fluid className='iphone-card'>
          <Card.Content>
            <Grid centered stackable verticalAlign='middle'>
              <Grid.Column width='6' textAlign='center'>
                <Icon name={this.props.icon} size='big' centered />
              </Grid.Column>
              <Grid.Column textAlign='center' width='10'>
                <h4>
                  <b>{this.props.text}</b>
                </h4>
              </Grid.Column>
            </Grid>
          </Card.Content>
        </Card>
      </Grid.Column>
    )
  }
}
